/**
 * @generated SignedSource<<84c55494d9b306533a72b420b9d34aff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LicenseProductDataContentKind = "CertificationContent" | "CourseContent" | "CourseWithCertificationContent";
export type EditLicenseProductInput = {
  clientMutationId?: string | null;
  content?: LicenseProductDataContentInput | null;
  id: string;
  licenseDefinitionAmount?: number | null;
  licenseDefinitionId: string;
};
export type LicenseProductDataContentInput = {
  CertificationContent?: CertificationContentInput | null;
  CourseContent?: CourseContentInput | null;
  CourseWithCertificationContent?: CourseWithCertificationContentInput | null;
};
export type CourseContentInput = {
  kind: LicenseProductDataContentKind;
};
export type CertificationContentInput = {
  kind: LicenseProductDataContentKind;
};
export type CourseWithCertificationContentInput = {
  kind: LicenseProductDataContentKind;
};
export type licenseProductForm_EditLicenseProductMutation$variables = {
  input: EditLicenseProductInput;
};
export type licenseProductForm_EditLicenseProductMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly editLicenseProduct: {
        readonly product: {
          readonly " $fragmentSpreads": FragmentRefs<"licenseProductForm_LicenseProductFragment">;
        };
      } | null;
    };
  };
};
export type licenseProductForm_EditLicenseProductMutation = {
  response: licenseProductForm_EditLicenseProductMutation$data;
  variables: licenseProductForm_EditLicenseProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "licenseProductForm_EditLicenseProductMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditLicenseProductPayload",
                "kind": "LinkedField",
                "name": "editLicenseProduct",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "licenseProductForm_LicenseProductFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "licenseProductForm_EditLicenseProductMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditLicenseProductPayload",
                "kind": "LinkedField",
                "name": "editLicenseProduct",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isHidden",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isTaxFree",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "netPrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "licenseDefinitionAmount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LicenseDefinition",
                                "kind": "LinkedField",
                                "name": "licenseDefinition",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "kind",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LicenseProductData",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "867209b8c4e3351622400f534b5de8a3",
    "id": null,
    "metadata": {},
    "name": "licenseProductForm_EditLicenseProductMutation",
    "operationKind": "mutation",
    "text": "mutation licenseProductForm_EditLicenseProductMutation(\n  $input: EditLicenseProductInput!\n) {\n  Admin {\n    Billing {\n      editLicenseProduct(input: $input) {\n        product {\n          ...licenseProductForm_LicenseProductFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment licenseProductForm_LicenseProductFragment on Product {\n  id\n  title\n  isHidden\n  isTaxFree\n  netPrice\n  data {\n    __typename\n    ... on LicenseProductData {\n      licenseDefinitionAmount\n      licenseDefinition {\n        id\n        data {\n          __typename\n          name\n        }\n      }\n      content {\n        __typename\n        kind\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "78d1f4de4f1d1c3a836c4adc51113df0";

export default node;
